import { onAuthStateChanged } from 'firebase/auth';
import { ReactNode, createContext, useEffect, useState } from 'react';
import { auth, db } from './fb';
import Loading from './components/Loading';
import { CollectionReference, collection, doc, getDoc } from 'firebase/firestore';

// User type
export type User = {
    isAuthenticated: boolean;
    uid: string;
    verified: boolean;
    approved: boolean;
    usertype: string | undefined,
    photoURL: string | undefined,
};

// Create a Context
export const AuthContext = createContext<User>({ isAuthenticated: false, uid: "", verified: false, approved: false, usertype: "artist", photoURL: "" });

export const getUserData = async (uid: string) => {
    const userRef: CollectionReference = collection(db, 'users');
    const userDoc = doc(userRef, uid);
    const userDocSnap = await getDoc(userDoc);
    return userDocSnap.data();
};

function Auth({ children }: { children: ReactNode }) {

    const [user, setUser] = useState({
        isAuthenticated: false,
        uid: "",
        verified: false,
        approved: false,
        usertype: "artist",
        photoURL: "",
    });

    const [loading, setLoading] = useState(true);

    // Listen auth Firebase state change
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                const idTokenResult = await user.getIdTokenResult(true);
                const dataUser = await getUserData(user.uid);

                setUser({
                    isAuthenticated: !!user,
                    uid: user.uid,
                    verified: idTokenResult?.claims?.verified === 'true' || idTokenResult?.claims?.verified === true,
                    approved: !!idTokenResult?.claims?.approved,
                    usertype: `${dataUser?.usertype ?? "artist"}`,
                    photoURL: user.photoURL ?? "",
                });
            } else {
                setUser({
                    isAuthenticated: false,
                    uid: "",
                    verified: false,
                    approved: false,
                    usertype: "artist",
                    photoURL: "",
                });
            }
            setLoading(false);
        });

        // Cleanup subscription on unmount
        return () => unsubscribe();
    }, []);

    return (
        <AuthContext.Provider value={user}>
            {loading ? <Loading /> : children}
        </AuthContext.Provider>
    );
}

export default Auth;